import { Fragment, h } from 'preact';

import { formatTime } from '../helpers/format';
import { LatestNewsWrapper, LatestNewsTop, LatestNewsBody } from '../latest-news-wrapper';
import Card from '../../../components/3-molecules/card/card';
import SectionTitle from '../../../components/2-atoms/section-title/section-title';
import SetOfCards from '../../../components/4-organisms/set-of-cards/set-of-cards';
import Loader from '../../../components/2-atoms/loader/loader';
import Cta from '../../../components/2-atoms/cta/cta';
import { IconArrowLink } from '../../../components/1-foundation/icons/icons';
import { getDateFormatted } from '../../../../utils/dates';
import { isLatestNewsPage } from '../../../../utils/aem-utils';

const ctaAppend = <IconArrowLink modifiers={['arrow-navigation', 'arrow-link', 'c-primary']} />;
const sectionTitleModifiers = ['border'];

export function renderLatestNews({ state, widget, htmlProps, isRail }) {
  const lastDayTimestamp = state.contents?.[0]?.[0].editorialPublishedDate || null;
  let lastDate = lastDayTimestamp ? new Date(lastDayTimestamp) : new Date();

  const setOfCardsRenderCallback = () => (card) => {
    let dateHeaderHTML = null;
    const currentDate = new Date(card[0].editorialPublishedDate);
    const hasDateChanged = currentDate.getTime() < lastDate.getTime() && currentDate.getDate() !== lastDate.getDate();
    if (isLatestNewsPage() && hasDateChanged) {
      lastDate = currentDate;
      const { day, month, year } = getDateFormatted(lastDate, { month: 'long' });
      dateHeaderHTML = (
        <p className="c-card c-card--CA30-m c-card--CA30-t c-card--CA30-d">{`${day} ${month} ${year}`}</p>
      );
    }

    return (
      <Fragment>
        {dateHeaderHTML}
        <Card
          key={card[0].pubDate}
          modifiers={[...widget.styles.cardModifiers[htmlProps.position], 'no-image']}
          newsData={card[0]}
          intcmpCard={htmlProps.intcmpNews}
          target={htmlProps.target}
          time={formatTime(card[0].date)}
          timeOnSide
          showChannel={false}
          truncateTitle={false}
          rel={state.rel}
        />
      </Fragment>
    );
  };

  return (
    <LatestNewsWrapper isRail={isRail}>
      {isRail && (
        <LatestNewsTop>
          <SectionTitle modifiers={sectionTitleModifiers}>{htmlProps.widgetTitle}</SectionTitle>
        </LatestNewsTop>
      )}
      <LatestNewsBody isRail={isRail}>
        <SetOfCards
          cards={state.contents}
          modifiers={widget.styles.setsOfCardsModifiers[htmlProps.position]}
          render={setOfCardsRenderCallback()}
        />
        {state.isLoadingInfinite && <Loader modifiers={['medium']} style={{ marginTop: -40 }} />}
      </LatestNewsBody>
      {isRail && htmlProps.ctaDefaultLabel && (
        <div className="c-latest-news__label">
          <Cta
            modifiers={['secondary']}
            href={htmlProps.ctaDefaultUrl}
            append={ctaAppend}
            intcmpCta={htmlProps.intcmpCta}
          >
            {htmlProps.ctaDefaultLabel}
          </Cta>
        </div>
      )}
    </LatestNewsWrapper>
  );
}
